// Shared async thunks for both Shared and ValetTrolley slices
import { createAsyncThunk } from "@reduxjs/toolkit";
import networkHandler from "../../network/networkHandler";
import { EApiMiddlewareMethods } from "../../network/networkHandler.types";
import customNetworHandler from "network/customNetworHandler";
import { cWingsServiceBaseURL } from "config/Api.config";

// --- SHARED THUNKS ---

export const fetchPlanningList = createAsyncThunk(
  "Shared/FetchByCountry",
  async (
    { requestContinuationToken, searchBy, searchValue }: { requestContinuationToken?: string; searchBy: string; searchValue: string },
    { rejectWithValue }
  ) => {
    try {
      const request: any = {
        url: `order/${searchBy}/${searchValue}`,
        method: EApiMiddlewareMethods.GET,
      };
      if (requestContinuationToken) {
        request.headers = { "x-requestcontinuation-token": requestContinuationToken };
      }
      const { data } = await networkHandler(request, { isAuth: true });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchDynamicFiltersOrdersDropdownValues = createAsyncThunk(
  "Shared/FetchDynamicFiltersOrdersDropdownValues",
  async ({ filters }: { filters: any }, { rejectWithValue }) => {
    try {
      const request: any = {
        url: "order/dynamic-filter-count",
        method: EApiMiddlewareMethods.POST,
        data: filters,
      };
      const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchDynamicFiltersRoutesDropdownValues = createAsyncThunk(
  "Shared/FetchDynamicFiltersRoutesDropdownValues",
  async ({ filters }: { filters: any }, { rejectWithValue }) => {
    try {
      const request: any = {
        url: "route/dynamic-filter-count",
        method: EApiMiddlewareMethods.POST,
        data: filters,
      };
      const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchDeliveryReasons = createAsyncThunk(
  "Shared/FetchDeliveryReasons",
  async (params, { rejectWithValue }) => {
    try {
      const request: any = {
        url: `order/get-delivery-reasons/Default`,
        method: EApiMiddlewareMethods.GET,
      };
      const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const fetchPlanningOrderListByFilter = createAsyncThunk(
    "Shared/FetchOrdersByFilter",
    async (
      {
        filters
      }: {
        filters: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'order/filter',
          method: EApiMiddlewareMethods.POST,
          data: filters
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const fetchPlanningRouteListByFilter = createAsyncThunk(
    "Shared/FetchRoutesByFilter",
    async (
      {
        filters
      }: {
        filters: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/filter',
          method: EApiMiddlewareMethods.POST,
          data: filters
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const fetchAllDrivers = createAsyncThunk(
    "Shared/FetchAllDrivers",
    async (
      {
        payload
      }: {
        payload: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'assignee/drivers',
          method: EApiMiddlewareMethods.POST,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const fetchAllHelpers = createAsyncThunk(
    "Shared/FetchAllHelpers",
    async (
      {
        payload
      }: {
        payload: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'assignee/helpers',
          method: EApiMiddlewareMethods.POST,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const fetchAllVehicles = createAsyncThunk(
    "Shared/FetchAllVehicles",
    async (
      {
        payload
      }: {
        payload: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'vehicle/load',
          method: EApiMiddlewareMethods.POST,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const createDraftRoute = createAsyncThunk(
    "Shared/CreateDraftRoute",
    async (
      {
        params
      }: {
        params: any
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/draft/create',
          method: EApiMiddlewareMethods.POST,
          data: params
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const loadAllSlots = createAsyncThunk(
    "Shared/LoadAllSlots",
    async (
      {
        params
      }: {
        params: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/draft/load/slots',
          method: EApiMiddlewareMethods.POST,
          data: params
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );


  export const consignmentReplanning = createAsyncThunk(
    "Shared/ConsignmentReplanning",
    async (
      {
        params
      }: {
        params: any
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'order/replanning',
          method: EApiMiddlewareMethods.POST,
          data: params
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const fetchAllPlannedRoutes = createAsyncThunk(
    "Shared/FetchAllPlannedRoutes",
    async (
      {
        payload
      }: {
        payload: any
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/view',
          method: EApiMiddlewareMethods.POST,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const createAndEditRoute = createAsyncThunk(
    "Shared/CreateAndEditRoute",
    async (
      {
        payload,
        editMode
      }: {
        payload: any,
        editMode: boolean
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/edit',
          method: EApiMiddlewareMethods.POST,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const discardRouteChanges = createAsyncThunk(
    "Shared/DiscardRouteChanges",
    async (
      {
        params,
        redirect
      }: {
        params: any,
        redirect?: boolean
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/discard',
          method: EApiMiddlewareMethods.POST,
          data: params
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const publishRoutes = createAsyncThunk(
    "Shared/PublishRoutes",
    async (
      {
        payload
      }: {
        payload: any
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/publish',
          method: EApiMiddlewareMethods.POST,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const deleteRoute = createAsyncThunk(
    "Shared/DeleteRoute",
    async (
      {
        payload
      }: {
        payload: any
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/delete',
          method: EApiMiddlewareMethods.POST,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const updateConsignmentStatus = createAsyncThunk(
    "Shared/UpdateOrderStatus",
    async (
      {
        payload
      }: {
        payload: any
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'order/updateRouteStatus',
          method: EApiMiddlewareMethods.PUT,
          data: payload
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const fetchOrdersFilterChipsDisplayCount = createAsyncThunk(
    "Shared/FetchOrdersFilterChipsDisplayCount",
    async (
      {
        filters
      }: {
        filters: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'order/displayStatusCount',
          method: EApiMiddlewareMethods.POST,
          data: filters
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const fetchRoutesFilterChipsDisplayCount = createAsyncThunk(
    "Shared/FetchRoutesFilterChipsDisplayCount",
    async (
      {
        filters
      }: {
        filters: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'route/displayStatusCount',
          method: EApiMiddlewareMethods.POST,
          data: filters
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const fetchRouteConsignments = createAsyncThunk(
    "Shared/FetchRouteConsignments",
    async ({
      id
    }: {
      id: string
    },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: `route/get-consignments-by-route/${id}`,
          method: EApiMiddlewareMethods.POST,
          data: {}
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const exportToExcel = createAsyncThunk(
    "Shared/ExportOrderToExcel",
    async (
      {
        payload,
      }: {
        payload: object;
      },
      { rejectWithValue }
    ) => {
      try {
          const request = {
            url: '/fulfilment/v2/export/orders',
            method: EApiMiddlewareMethods.POST,
            data: payload,
            responseType: "blob"
          } as any;
          request.headers = {
            'generateResponse': false,
          }
          const response =  await customNetworHandler(request, cWingsServiceBaseURL);
          return response;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const exportRoutesToExcel = createAsyncThunk(
    "Shared/ExportRoutesToExcel",
    async (
      {
        payload,
      }: {
        payload: object;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: '/fulfilment/v2/export/routes',
          method: EApiMiddlewareMethods.POST,
          data: payload,
          responseType: "blob"
        } as any;
        request.headers = {
          'generateResponse': false,
        }
        const response =  await customNetworHandler(request, cWingsServiceBaseURL);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const exportInvoicePdf = createAsyncThunk(
    "Shared/ExportInvoicePdf",
    async (
      {
        params,
      }: {
        params: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: '/fulfilment/invoice/v1/view',
          method: EApiMiddlewareMethods.POST,
          data: params,
          responseType: "bytes"
        } as any;
        const { data } = await customNetworHandler(request, cWingsServiceBaseURL);
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  
  export const updateCustomerAddress = createAsyncThunk(
    "Shared/UpdateCustomerAddress",
    async (
      {
        params
      }: {
        params: any
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: 'order/update-delivery-address',
          method: EApiMiddlewareMethods.POST,
          data: params
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const updateAllConsignmentsState = createAsyncThunk("Shared/UpdateAllConsignmentsState", ({
    consignments
  }: {
    consignments: any
  }) => {
    return consignments;
  });
  
  export const clearPublishedRoutesErrors = createAsyncThunk("Shared/ClearPublishedRoutesErrors", () => {
    return [];
  });
  
  export const clearPublishedRoutes = createAsyncThunk("Shared/ClearPublishedRoutes", () => {
    return [];
  });
  
  export const resetPlanningError = createAsyncThunk("Shared/ResetPlanningError", () => {
    return "";
  });
  
  export const clearUpdatedRoute = createAsyncThunk("Shared/ClearUpdatedRoute", () => {
    return null;
  });
  
  export const clearDeletedRoute = createAsyncThunk("Shared/ClearDeletedRoute", () => {
    return null;
  });
  
  export const resetCreateRouteSuccess = createAsyncThunk("Shared/ResetCreateRouteSuccess", () => {
    return false;
  });
  
  export const resetDraftRoute = createAsyncThunk("Shared/ResetDraftRoute", () => {
    return {};
  });
  
  export const resetConsignmentReplanningSuccess = createAsyncThunk("Shared/ResetConsignmentReplanningSuccess", () => {
    return false;
  });
  
  export const clearCurrentSlot = createAsyncThunk("Shared/ClearCurrentSlot", () => {
    return null;
  });
  
  export const resetExportInitiated = createAsyncThunk("Shared/ResetExportInitiated", () => {  
    return false;
  });
  
  export const fetchConsignmentHistoryAndProducts = createAsyncThunk(
    "Shared/FetchConsignmentHistoryAndProducts",
    async (
      {
        params
      }: {
        params: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: `order/statusHistoryProducts/${params} `,
          method: EApiMiddlewareMethods.GET,
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const getCratesInfo = createAsyncThunk(
    "Shared/getCratesInfo",
    async (
      {
        params,
      }: {
        params: any;
      },
      { rejectWithValue }
    ) => {
      try {
        const request = {
          url: `order / updateCratesAlectoApi`,
          method: EApiMiddlewareMethods.POST,
          data: params,
        } as any;
        const { data } = await networkHandler(request, { isAuth: true, isUAE: true });
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
 
  

  
  export const closeDialog = createAsyncThunk("Shared/CloseDialog", () => {
    return false;
  });
  
  export const resetReplanningSuccess = createAsyncThunk("Shared/ResetReplanningSuccess", () => {
    return false;
  });
  
  export const updateAddressSuccess = createAsyncThunk("VTAddressUpdate/AddressUpdateSuccess", () => {
    return false;
  });
